import type { PricesState } from '@/infrastructure/prices/store';

export function isCreateBookingDraftLoading(state: PricesState) {
  return state.createBookingDraft.loading;
}

export function hasBookingDraftCreationFailed(state: PricesState) {
  return state.createBookingDraft.error;
}

export function hasBookingDraftCreationSucceeded(state: PricesState) {
  return state.createBookingDraft.success;
}
